// extracted by mini-css-extract-plugin
module.exports = {"option":"account-selection-modal_option__r3ndX"};